// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/event_staffing.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { OrganizationUserType } from "./organizations_pb";
import { file_cortado_v1_organizations } from "./organizations_pb";
import type { UserSchedulingRoleEnum, UserSchedulingStatusEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/event_staffing.proto.
 */
export const file_cortado_v1_event_staffing: GenFile = /*@__PURE__*/
  fileDesc("Ch9jb3J0YWRvL3YxL2V2ZW50X3N0YWZmaW5nLnByb3RvEgpjb3J0YWRvLnYxIjUKIUxpc3RFdmVudFN0YWZmQXZhaWxhYmlsaXR5UmVxdWVzdBIQCghldmVudF9pZBgBIAEoCSLFAgoWU3RhZmZVbmF2YWlsYWJsZVJlYXNvbhI4CgRraW5kGAEgASgOMiouY29ydGFkby52MS5TdGFmZlVuYXZhaWxhYmxlUmVhc29uS2luZEVudW0SDQoFbGFiZWwYAiABKAkSFQoIZXZlbnRfaWQYCiABKAlIAIgBARITCgZqb2JfaWQYCyABKAlIAYgBARIzCgpidXN5X3N0YXJ0GAwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgCiAEBEjEKCGJ1c3lfZW5kGA0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgDiAEBEhEKBGRhdGUYFCABKAlIBIgBAUILCglfZXZlbnRfaWRCCQoHX2pvYl9pZEINCgtfYnVzeV9zdGFydEILCglfYnVzeV9lbmRCBwoFX2RhdGUiwwMKE0V2ZW50U3RhZmZDYW5kaWRhdGUSDwoHdXNlcl9pZBgBIAEoCRIXCgpmaXJzdF9uYW1lGAIgASgJSACIAQESFgoJbGFzdF9uYW1lGAMgASgJSAGIAQESEgoFZW1haWwYBCABKAlIAogBARIzCgl1c2VyX3R5cGUYBSABKA4yIC5jb3J0YWRvLnYxLk9yZ2FuaXphdGlvblVzZXJUeXBlEhEKCWF2YWlsYWJsZRgKIAEoCBIzCgdyZWFzb25zGAsgAygLMiIuY29ydGFkby52MS5TdGFmZlVuYXZhaWxhYmxlUmVhc29uEhoKDXNjaGVkdWxpbmdfaWQYFCABKAlIA4gBARI1CgRyb2xlGBUgASgOMiIuY29ydGFkby52MS5Vc2VyU2NoZWR1bGluZ1JvbGVFbnVtSASIAQESOQoGc3RhdHVzGBYgASgOMiQuY29ydGFkby52MS5Vc2VyU2NoZWR1bGluZ1N0YXR1c0VudW1IBYgBAUINCgtfZmlyc3RfbmFtZUIMCgpfbGFzdF9uYW1lQggKBl9lbWFpbEIQCg5fc2NoZWR1bGluZ19pZEIHCgVfcm9sZUIJCgdfc3RhdHVzIskCCiJMaXN0RXZlbnRTdGFmZkF2YWlsYWJpbGl0eVJlc3BvbnNlEjUKDHdpbmRvd19zdGFydBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIzCgp3aW5kb3dfZW5kGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEhwKFHdpbmRvd19mcm9tX3RpbWVsaW5lGAMgASgIEhAKCHRpbWV6b25lGAQgASgJEhQKDHN0YWZmX25lZWRlZBgFIAEoBRIcChRzdGFmZl9hc3NpZ25lZF9jb3VudBgGIAEoBRIzCgpjYW5kaWRhdGVzGAogAygLMh8uY29ydGFkby52MS5FdmVudFN0YWZmQ2FuZGlkYXRlQg8KDV93aW5kb3dfc3RhcnRCDQoLX3dpbmRvd19lbmQqugEKHlN0YWZmVW5hdmFpbGFibGVSZWFzb25LaW5kRW51bRItCilTVEFGRl9VTkFWQUlMQUJMRV9SRUFTT05fS0lORF9VTlNQRUNJRklFRBAAEjgKNFNUQUZGX1VOQVZBSUxBQkxFX1JFQVNPTl9LSU5EX09WRVJMQVBQSU5HX0FTU0lHTk1FTlQQARIvCitTVEFGRl9VTkFWQUlMQUJMRV9SRUFTT05fS0lORF9CTEFDS09VVF9EQVRFEAJCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_cortado_v1_organizations, file_cortado_v1_settings, file_google_protobuf_timestamp]);

/**
 * @generated from message cortado.v1.ListEventStaffAvailabilityRequest
 */
export type ListEventStaffAvailabilityRequest = Message<"cortado.v1.ListEventStaffAvailabilityRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.ListEventStaffAvailabilityRequest.
 * Use `create(ListEventStaffAvailabilityRequestSchema)` to create a new message.
 */
export const ListEventStaffAvailabilityRequestSchema: GenMessage<ListEventStaffAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_staffing, 0);

/**
 * @generated from message cortado.v1.StaffUnavailableReason
 */
export type StaffUnavailableReason = Message<"cortado.v1.StaffUnavailableReason"> & {
  /**
   * @generated from field: cortado.v1.StaffUnavailableReasonKindEnum kind = 1;
   */
  kind: StaffUnavailableReasonKindEnum;

  /**
   * Ready-to-show text, e.g. "Booked on Wedding · Oct 22, 7:00 AM – 1:30 PM"
   * or "Blackout date · Staff retreat".
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * OVERLAPPING_ASSIGNMENT only.
   *
   * @generated from field: optional string event_id = 10;
   */
  eventId?: string;

  /**
   * @generated from field: optional string job_id = 11;
   */
  jobId?: string;

  /**
   * The other event's busy window: the union of the assignment's shift and
   * that event's on-site window.
   *
   * @generated from field: optional google.protobuf.Timestamp busy_start = 12;
   */
  busyStart?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp busy_end = 13;
   */
  busyEnd?: Timestamp;

  /**
   * BLACKOUT_DATE only: YYYY-MM-DD.
   *
   * @generated from field: optional string date = 20;
   */
  date?: string;
};

/**
 * Describes the message cortado.v1.StaffUnavailableReason.
 * Use `create(StaffUnavailableReasonSchema)` to create a new message.
 */
export const StaffUnavailableReasonSchema: GenMessage<StaffUnavailableReason> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_staffing, 1);

/**
 * EventStaffCandidate is one org member and whether they can work the event.
 *
 * @generated from message cortado.v1.EventStaffCandidate
 */
export type EventStaffCandidate = Message<"cortado.v1.EventStaffCandidate"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: optional string first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 3;
   */
  lastName?: string;

  /**
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * @generated from field: cortado.v1.OrganizationUserType user_type = 5;
   */
  userType: OrganizationUserType;

  /**
   * True when no reason applies. A member already assigned to this event is
   * still checked against their other assignments.
   *
   * @generated from field: bool available = 10;
   */
  available: boolean;

  /**
   * @generated from field: repeated cortado.v1.StaffUnavailableReason reasons = 11;
   */
  reasons: StaffUnavailableReason[];

  /**
   * Set when the member is assigned to this event.
   *
   * @generated from field: optional string scheduling_id = 20;
   */
  schedulingId?: string;

  /**
   * @generated from field: optional cortado.v1.UserSchedulingRoleEnum role = 21;
   */
  role?: UserSchedulingRoleEnum;

  /**
   * @generated from field: optional cortado.v1.UserSchedulingStatusEnum status = 22;
   */
  status?: UserSchedulingStatusEnum;
};

/**
 * Describes the message cortado.v1.EventStaffCandidate.
 * Use `create(EventStaffCandidateSchema)` to create a new message.
 */
export const EventStaffCandidateSchema: GenMessage<EventStaffCandidate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_staffing, 2);

/**
 * @generated from message cortado.v1.ListEventStaffAvailabilityResponse
 */
export type ListEventStaffAvailabilityResponse = Message<"cortado.v1.ListEventStaffAvailabilityResponse"> & {
  /**
   * The on-site window availability was checked against: the first timeline
   * block's start to the last block's end. Falls back to service time when
   * the event has no timeline (no date).
   *
   * @generated from field: optional google.protobuf.Timestamp window_start = 1;
   */
  windowStart?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_end = 2;
   */
  windowEnd?: Timestamp;

  /**
   * True when the window came from the computed run of show; false when it
   * is service time only (or unset for an undated event).
   *
   * @generated from field: bool window_from_timeline = 3;
   */
  windowFromTimeline: boolean;

  /**
   * IANA zone the window is shown in (event, then org, then UTC).
   *
   * @generated from field: string timezone = 4;
   */
  timezone: string;

  /**
   * Staff needed: Event.barista_count, at least 1 (an event that does not
   * say how many it needs still needs someone).
   *
   * @generated from field: int32 staff_needed = 5;
   */
  staffNeeded: number;

  /**
   * Assignments on this event that are not rejected.
   *
   * @generated from field: int32 staff_assigned_count = 6;
   */
  staffAssignedCount: number;

  /**
   * Every org member, assigned first (Lead first), then available, then
   * unavailable, each by name.
   *
   * @generated from field: repeated cortado.v1.EventStaffCandidate candidates = 10;
   */
  candidates: EventStaffCandidate[];
};

/**
 * Describes the message cortado.v1.ListEventStaffAvailabilityResponse.
 * Use `create(ListEventStaffAvailabilityResponseSchema)` to create a new message.
 */
export const ListEventStaffAvailabilityResponseSchema: GenMessage<ListEventStaffAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_staffing, 3);

/**
 * @generated from enum cortado.v1.StaffUnavailableReasonKindEnum
 */
export enum StaffUnavailableReasonKindEnum {
  /**
   * @generated from enum value: STAFF_UNAVAILABLE_REASON_KIND_UNSPECIFIED = 0;
   */
  STAFF_UNAVAILABLE_REASON_KIND_UNSPECIFIED = 0,

  /**
   * Assigned (not rejected) to another live event whose shift or on-site
   * window overlaps this event's on-site window.
   *
   * @generated from enum value: STAFF_UNAVAILABLE_REASON_KIND_OVERLAPPING_ASSIGNMENT = 1;
   */
  STAFF_UNAVAILABLE_REASON_KIND_OVERLAPPING_ASSIGNMENT = 1,

  /**
   * The on-site window touches one of the org's unavailable (blackout) dates.
   *
   * @generated from enum value: STAFF_UNAVAILABLE_REASON_KIND_BLACKOUT_DATE = 2;
   */
  STAFF_UNAVAILABLE_REASON_KIND_BLACKOUT_DATE = 2,
}

/**
 * Describes the enum cortado.v1.StaffUnavailableReasonKindEnum.
 */
export const StaffUnavailableReasonKindEnumSchema: GenEnum<StaffUnavailableReasonKindEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_event_staffing, 0);

